export const config = {
  providers: {
    firebase: {
      apiKey: "AIzaSyByvBzglGO-EDcyMQ-NzRPTu4SAKnua3HI",
	    authDomain: "smiledentist-f17af.firebaseapp.com",
	    databaseURL: "https://smiledentist-f17af.firebaseio.com",
	    projectId: "smiledentist-f17af",
	    storageBucket: "smiledentist-f17af.appspot.com",
	    messagingSenderId: "422252407581"
    },
  },
  serverUrl: process.env.REACT_APP_BACKEND_URL || 'https://smiledentist-backend-qrenen54da-uc.a.run.app',
  frontEndUrl: process.env.REACT_APP_FRONTEND_URL || 'https://smiledentist.com',
}